import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'Report/UsageProcessTypes', method: 'GET', body: filter, token: token })
}
